import './styles/index.css';
import { initApp } from './app.tsx';

initApp();
